export default __webpack_public_path__ + "static/media/asset-jubi-bolsa.4060e8d3.png";